import { CKForm } from 'console-kit';

const ValidatableEmailInput = CKForm.ValidatableInput({
  isRequired: CKForm.Validators.isRequired(),
  isValid:    value => {
    const re = /^(([^<>()\[\]\\.,;:\s@“]+(\.[^<>()\[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(String(value).toLowerCase())) return 'Invalid email address provided';
    return false;
  },
});

export default ValidatableEmailInput;
